import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "width", "title"];
import React from 'react';
import Svg from '../Svg';

var RoundedHamburger = function RoundedHamburger(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#42368E' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1.5rem' : _ref$width,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Menu icon' : _ref$title,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Svg, _extends({
    title: title,
    width: width,
    viewBox: "0 0 15 16",
    fill: "none"
  }, rest), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.00003C0 8.6358 0.515389 9.15118 1.15115 9.15118L13.8488 9.15118C14.4846 9.15118 15 8.6358 15 8.00003C15 7.36427 14.4846 6.84888 13.8488 6.84888L1.15115 6.84888C0.515389 6.84888 0 7.36427 0 8.00003Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.8605C0 2.49626 0.515387 3.01165 1.15115 3.01165L13.8489 3.01165C14.4846 3.01165 15 2.49626 15 1.8605C15 1.22474 14.4846 0.709351 13.8489 0.709351L1.15115 0.709351C0.515388 0.709351 0 1.22474 0 1.8605Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.1396C0 14.7753 0.515388 15.2907 1.15115 15.2907L5.84885 15.2907C6.48461 15.2907 7 14.7753 7 14.1396C7 13.5038 6.48461 12.9884 5.84885 12.9884L1.15115 12.9884C0.515388 12.9884 0 13.5038 0 14.1396Z",
    fill: color
  }));
};

export default RoundedHamburger;